export default __webpack_public_path__ + "static/media/erigrid2.772c0db5.png";